export default "__VITE_ASSET__79f18b48__"